<template>
    <div class="col-xl-4 col-lg-6 col-md-12">
        <RouterLink :to="route" class="card bg-light nav-card">
            <div class="card-img-top text-center">
                <slot name="imageContent"></slot>
            </div>
            <div class="card-body">
                <p class="card-text">
                    <slot name="textContent"></slot>
                </p>
            </div>
        </RouterLink>
    </div>
</template>

<script>
    export default {
        props: {
            route: {
                type: Object,
                required: true
            }
        }
    };
</script>

<style scoped>
    .nav-card {
        border-radius: 0;
        height: 225px;
        margin-bottom: 20px;
        margin-left: auto;
        margin-right: auto;
        padding-top: 10px;
        width: 300px;
    }

    .nav-card .card-img-top {
        color: rgb(0, 32, 96);
    }

    .nav-card .card-text {
        color: rgb(84, 125, 199);
        font-size: x-large;
        font-weight: bold;
        text-align: center;
    }

    .nav-card:hover {
        text-decoration: none;
    }
</style>
